import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DisposalSitesComponent} from './disposal-sites.component';
const routes: Routes = [
  {
    path: '',
    component: DisposalSitesComponent,
    
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DisposalSitesRoutingModule { }
